import type { PortfolioUploadType } from "@components/PortfolioScreenshotModal/types";
import { getBridge } from "@/src/lib/bridge/bridge";
import { stabilizePickedFiles } from "./stabilizePickedFiles";

/**
 * Clone picker files into memory before upload (required on Android WebView).
 */
export async function preparePortfolioUploadFiles(
  uploadType: PortfolioUploadType,
  files: File[],
): Promise<File[]> {
  if (!getBridge().isInApp() || files.length === 0) {
    return files;
  }

  const stabilized = await stabilizePickedFiles(files, {
    defaultMimeType: uploadType === "pdf" ? "application/pdf" : "image/jpeg",
  });

  return stabilized.length > 0 ? stabilized : files;
}
